import { render } from "./App.vue?vue&type=template&id=91b19b7c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=91b19b7c&lang=css"

import exportComponent from "/Users/malina/mySpace/work/v-art/protocol/template-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__